import { render } from "./WorkflowNavigation.vue?vue&type=template&id=766a20ec&ts=true"
import script from "./WorkflowNavigation.vue?vue&type=script&lang=ts"
export * from "./WorkflowNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__